// @flow
import React from 'react';
import PropTypes from 'prop-types';

type Props = {
  imgSrc: string,
  imgAlt: string,
  children?: Node,
};
const GettingStartedItemComponent = ({ imgSrc, imgAlt, children }: Props) => (
  <figure className="getting-started-component__item u-padding-m">
    <img alt={imgAlt} src={imgSrc} className="getting-startedproduct-type-select-component__menu-component__image" />
    {children}
  </figure>
);

GettingStartedItemComponent.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  children: PropTypes.node,
};

GettingStartedItemComponent.defaults = {
  children: [],
};

export default GettingStartedItemComponent;
